import IDocumentoLIO, { IDocumentoLIOAspectoEvaluar } from "../entities/IDocumentoLIO";
import IInspeccionAspectoEvaluar, { ISetAspectoEvaluar } from "../entities/IInspeccionAspectoEvaluar";
import IInspeccionObservacion, {
  IGestionLIO,
  IAspectoEvaluar,
  ICalculoLIO,
  ICerrarAspecto,
  IEnviarLIO,
  ISearchByTipoBusquedaLIO,
  ISearchGestionLIO,
  ISearchHistoricoLIO,
  ISearchListadoAspectosInsObs,
  ISearchReporteLIO,
  ISearchReporteSabanaLIO,
  ISearchReporteEtapasDecisionesLIO,
} from "../entities/IInspeccionObservacion";
import { IResponseAPI } from "../entities/IResponseAPI";
import ICurrentUser from "../entities/helper/ICurrentUser";
import { deleteAPI, getAPI, postAPI, getAPIBlob } from "../helpers/httpHelper";
import {
  API_DESVIACION_DELETE_ELIMINARLIO,
  API_DESVIACION_DELETE_ELIMINARLIOASPECTO,
  API_DESVIACION_POST_DESACTIVARLIO,
  API_DESVIACION_POST_DESACTIVARLIOASPECTO,
  API_LIO_DELETE_DOCUMENTOLIO,
  API_LIO_DELETE_DOCUMENTOLIOASPECTOEVALUAR,
  API_LIO_GET_ASPECTO_EVALUAR,
  API_LIO_GET_CALCULOLIO,
  API_LIO_GET_DOCUMENTOSLIO,
  API_LIO_GET_DOCUMENTOSLIOASPECTOEVALUAR,
  API_LIO_GET_EXCELHISTORICO,
  API_LIO_GET_EXCELREPORTELIO,
  API_LIO_GET_EXCELREPORTESABANALIO,
  API_LIO_GET_GESTIONARLIO,
  API_LIO_GET_LIO,
  API_LIO_GET_LISTADOASIGNADASHOME,
  API_LIO_GET_LISTADOASPECTOSASIGNADOSINSOBS,
  API_LIO_GET_LISTADOASPECTOSINSOBS,
  API_LIO_GET_LISTADOLIOHISTORICO,
  API_LIO_GET_LISTADOLIOHOME,
  API_LIO_GET_LISTADOREPORTELIO,
  API_LIO_GET_LISTADOREPORTESABANA,
  API_LIO_POST_CERRARASPECTOEVALUADO,
  API_LIO_POST_DOCUMENTOLIO,
  API_LIO_POST_DOCUMENTOSLIOASPECTOEVALUAR,
  API_LIO_POST_ENVIARLIO,
  API_LIO_POST_INSPECCIONOBSERVACION,
  API_LIO_POST_SETASPECTOEVALUAR,
  ROW_COUNT,
  ROW_COUNT_MAX,
  URL_LIO,
  API_LIO_GET_LISTADO_REPORTE_ETAPAS_DECISIONES,
  API_LIO_GET_EXCEL_REPORTE_ETAPAS_DECISIONES_LIO,
} from "../helpers/variableHelper";
import { IDesactivarRegistro } from "../entities/ILogMantenedor";

export default class LIOService {
  public static async getLIOByID(token: string, id: number): Promise<IInspeccionObservacion | null> {
    try {
      let result = (
        await getAPI(
          `${URL_LIO}${API_LIO_GET_LIO}`,
          { Authorization: `Bearer ${token}` },
          {
            ID_INSPECCION: id,
          }
        )
      ).result;
      return result.data || null;
    } catch (e) {
      return {} as IInspeccionObservacion;
    }
  }

  public static async getEstadisticasHome(token: string, currUser: ICurrentUser): Promise<ICalculoLIO> {
    try {
      let resultCalculoHome = (
        await getAPI(
          `${URL_LIO}${API_LIO_GET_CALCULOLIO}`,
          { Authorization: `Bearer ${token}` },
          {
            USUARIO: currUser?.email,
          }
        )
      ).result;

      return resultCalculoHome.data;
    } catch (e) {
      return {} as ICalculoLIO;
    }
  }

  public static async getListadoLIOHome(token: string, searchLIO: ISearchByTipoBusquedaLIO): Promise<IResponseAPI<Array<IInspeccionObservacion>>> {
    try {
      let resultCalculoHome = (
        await getAPI(
          `${URL_LIO}${API_LIO_GET_LISTADOLIOHOME}`,
          { Authorization: `Bearer ${token}` },
          {
            ...searchLIO,
          }
        )
      ).result;

      return resultCalculoHome;
    } catch (e) {
      return {} as IResponseAPI<Array<IInspeccionObservacion>>;
    }
  }

  public static async getListadoAspectosInsObs(token: string, params: ISearchListadoAspectosInsObs): Promise<IResponseAPI<Array<IAspectoEvaluar>>> {
    try {
      let resultCalculoHome = (await getAPI(`${URL_LIO}${API_LIO_GET_LISTADOASPECTOSINSOBS}`, { Authorization: `Bearer ${token}` }, params)).result;

      return resultCalculoHome;
    } catch (e) {
      return { data: [], message: "", pages: 0, resultCode: 500 } as IResponseAPI<Array<IAspectoEvaluar>>;
    }
  }

  public static async getListadoAspectoAsignadoInsObs(token: string, params: IAspectoEvaluar): Promise<IResponseAPI<Array<IAspectoEvaluar>>> {
    try {
      let resultCalculoHome = (await getAPI(`${URL_LIO}${API_LIO_GET_LISTADOASPECTOSASIGNADOSINSOBS}`, { Authorization: `Bearer ${token}` }, params))
        .result;

      return resultCalculoHome;
    } catch (e) {
      return {} as IResponseAPI<Array<IAspectoEvaluar>>;
    }
  }

  public static async getListadoAsignadasHome(
    token: string,
    searchLIO: ISearchByTipoBusquedaLIO
  ): Promise<IResponseAPI<Array<IInspeccionAspectoEvaluar>>> {
    try {
      let resultCalculoHome = (
        await getAPI(
          `${URL_LIO}${API_LIO_GET_LISTADOASIGNADASHOME}`,
          { Authorization: `Bearer ${token}` },
          {
            ...searchLIO,
          }
        )
      ).result;

      return resultCalculoHome;
    } catch (e) {
      return { data: [], message: "", pages: 0, resultCode: 500 } as IResponseAPI<Array<IInspeccionAspectoEvaluar>>;
    }
  }

  public static async ingresoLIO(token: string, value: Partial<IInspeccionObservacion>): Promise<number> {
    try {
      let result = await postAPI(`${URL_LIO}${API_LIO_POST_INSPECCIONOBSERVACION}`, value, {
        Authorization: `Bearer ${token}`,
      });

      return result.result.data.data;
    } catch (error) {
      console.error(error);
      return -1;
    }
  }

  public static async addDocumentosLIO(token: string, value: Partial<IDocumentoLIO>) {
    try {
      const formData = new FormData();
      formData.append("ID_TIPO_DOCUMENTO", value.ID_TIPO_DOCUMENTO?.toString() || "");
      formData.append("ID_LIO_INSPECCION_OBSERVACION", value.ID_LIO_INSPECCION_OBSERVACION?.toString() || "");
      formData.append("DESCRIPCION", value.DESCRIPCION as string);
      formData.append("FILE", value.FILE);
      delete value.FILE;
      let result = await postAPI(`${URL_LIO}${API_LIO_POST_DOCUMENTOLIO}`, formData, { Authorization: `Bearer ${token}` }, value);

      return result.result.data;
    } catch (error) {
      console.error(error);
    }
  }

  public static async deleteDocumentoLIO(token: string, idDocumento: number): Promise<ICalculoLIO> {
    try {
      let resultCalculoHome = (
        await deleteAPI(
          `${URL_LIO}${API_LIO_DELETE_DOCUMENTOLIO}`,
          { Authorization: `Bearer ${token}` },
          {
            ID: idDocumento,
          }
        )
      ).result;

      return resultCalculoHome.data;
    } catch (e) {
      return {} as ICalculoLIO;
    }
  }

  public static async getDocumentosLIO(token: string, query: Partial<IDocumentoLIO>): Promise<IResponseAPI<Array<IDocumentoLIO>>> {
    if (!query.PAGINA) {
      query.PAGINA = 1;
    }
    if (!query.PAGINADO) {
      query.PAGINADO = ROW_COUNT;
    }
    if (!query.ORDENADOPOR) {
      query.ORDENADOPOR = "ID";
    }
    if (!query.ORIENTACION) {
      query.ORIENTACION = "DESC";
    }

    try {
      let resultCalculoHome = (
        await getAPI(
          `${URL_LIO}${API_LIO_GET_DOCUMENTOSLIO}`,
          { Authorization: `Bearer ${token}` },
          {
            ...query,
          }
        )
      ).result;

      return resultCalculoHome;
    } catch (error) {
      return {
        data: [],
        message: "",
        pages: 0,
        resultCode: 500,
      };
    }
  }

  public static async cerrarAspectoEvaluado(token: string, value: ICerrarAspecto) {
    try {
      let result = await postAPI(`${URL_LIO}${API_LIO_POST_CERRARASPECTOEVALUADO}`, value, {
        Authorization: `Bearer ${token}`,
      });

      return result.result.data;
    } catch (error) {
      console.error(error);
    }
  }

  public static async enviarLIO(token: string, value: IEnviarLIO) {
    try {
      let result = await postAPI(`${URL_LIO}${API_LIO_POST_ENVIARLIO}`, value, {
        Authorization: `Bearer ${token}`,
      });

      return result.result.data;
    } catch (error) {
      console.error(error);
    }
  }

  public static async getAspectoEvaluarByID(token: string, id: number): Promise<IAspectoEvaluar | null> {
    try {
      let result = (
        await getAPI(
          `${URL_LIO}${API_LIO_GET_ASPECTO_EVALUAR}`,
          { Authorization: `Bearer ${token}` },
          {
            ID_ASPECTO_EVALUAR: id,
          }
        )
      ).result;
      return result.data || null;
    } catch (e) {
      return {} as IAspectoEvaluar;
    }
  }

  public static async getDocumentosLIOAspectoEvaluar(
    token: string,
    query: Partial<IDocumentoLIOAspectoEvaluar>
  ): Promise<IResponseAPI<Array<IDocumentoLIOAspectoEvaluar>>> {
    if (!query.PAGINA) {
      query.PAGINA = 1;
    }
    if (!query.PAGINADO) {
      query.PAGINADO = ROW_COUNT;
    }
    if (!query.ORDENADOPOR) {
      query.ORDENADOPOR = "ID";
    }
    if (!query.ORIENTACION) {
      query.ORIENTACION = "DESC";
    }

    try {
      let resultCalculoHome = (
        await getAPI(
          `${URL_LIO}${API_LIO_GET_DOCUMENTOSLIOASPECTOEVALUAR}`,
          { Authorization: `Bearer ${token}` },
          {
            ...query,
          }
        )
      ).result;

      return resultCalculoHome;
    } catch (error) {
      return {
        data: [],
        message: "",
        pages: 0,
        resultCode: 500,
      };
    }
  }

  public static async addDocumentosLIOAspectoEvaluar(token: string, value: Partial<IDocumentoLIOAspectoEvaluar>) {
    try {
      const formData = new FormData();
      formData.append("ID_TIPO_DOCUMENTO", value.ID_TIPO_DOCUMENTO?.toString() || "");
      formData.append("ID_LIO_INSPECCION_OBSERVACION", value.ID_LIO_INSPECCION_OBSERVACION?.toString() || "");
      formData.append("ID_LIO_ASPECTO_EVALUAR", value.ID_LIO_ASPECTO_EVALUAR?.toString() || "");
      formData.append("DESCRIPCION", value.DESCRIPCION as string);
      formData.append("FILE", value.FILE);
      delete value.FILE;
      let result = await postAPI(`${URL_LIO}${API_LIO_POST_DOCUMENTOSLIOASPECTOEVALUAR}`, formData, { Authorization: `Bearer ${token}` }, value);

      return result.result.data;
    } catch (error) {
      console.error(error);
    }
  }

  public static async setAspectoEvaluarAccionAsignada(token: string, value: ISetAspectoEvaluar): Promise<number> {
    try {
      let result = await postAPI(`${URL_LIO}${API_LIO_POST_SETASPECTOEVALUAR}`, value, {
        Authorization: `Bearer ${token}`,
      });

      return result.result.data.data;
    } catch (error) {
      console.error(error);
      return -1;
    }
  }

  public static async deleteDocumentoLIOAspectoEvaluar(token: string, idDocumento: number): Promise<ICalculoLIO> {
    try {
      let resultCalculoHome = (
        await deleteAPI(
          `${URL_LIO}${API_LIO_DELETE_DOCUMENTOLIOASPECTOEVALUAR}`,
          { Authorization: `Bearer ${token}` },
          {
            ID: idDocumento,
          }
        )
      ).result;

      return resultCalculoHome.data;
    } catch (e) {
      return {} as ICalculoLIO;
    }
  }

  public static async getListadoHistorico(token: string, search: ISearchHistoricoLIO) {
    try {
      let result = (
        await getAPI(
          `${URL_LIO}${API_LIO_GET_LISTADOLIOHISTORICO}`,
          { Authorization: `Bearer ${token}` },
          {
            ...search,
          }
        )
      ).result;

      return result;
    } catch (e) {
      return false;
    }
  }

  public static async getListadoReporteLIO(token: string, search: ISearchReporteLIO) {
    try {
      let result = (
        await getAPI(
          `${URL_LIO}${API_LIO_GET_LISTADOREPORTELIO}`,
          { Authorization: `Bearer ${token}` },
          {
            ...search,
          }
        )
      ).result;

      return result;
    } catch (e) {
      return false;
    }
  }

  public static async getListadoReporteSabanaLIO(token: string, search: ISearchReporteSabanaLIO) {
    try {
      let result = (
        await getAPI(
          `${URL_LIO}${API_LIO_GET_LISTADOREPORTESABANA}`,
          { Authorization: `Bearer ${token}` },
          {
            ...search,
          }
        )
      ).result;

      return result;
    } catch (e) {
      return false;
    }
  }

  public static async getGestionLIO(token: string, search: ISearchGestionLIO): Promise<IResponseAPI<Array<IGestionLIO>>> {
    try {
      let result = (
        await getAPI(
          `${URL_LIO}${API_LIO_GET_GESTIONARLIO}`,
          { Authorization: `Bearer ${token}` },
          {
            ...search,
          }
        )
      ).result;

      return result;
    } catch (e) {
      return {} as IResponseAPI<Array<IGestionLIO>>;
    }
  }

  public static async getExcelHistorico(token: string, search: ISearchHistoricoLIO) {
    await getAPIBlob(
      `${URL_LIO}${API_LIO_GET_EXCELHISTORICO}`,
      { Authorization: `Bearer ${token}` },
      {
        ...search,
        ORDENADOPOR: "ID",
        ORIENTACION: "DESC",
        PAGINA: 1,
        PAGINADO: ROW_COUNT_MAX,
      }
    )
      .then((r) => {
        let file = r.result;
        let fileURL = URL.createObjectURL(file);
        let fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.download = "ReporteHistorico.xlsx";
        fileLink.click();
      })
      .catch((e) => {
        console.log(e);
      });
  }

  public static async getExcelReporteLIO(token: string, search: ISearchReporteLIO) {
    let sendingEmail = false;
    await getAPIBlob(
      `${URL_LIO}${API_LIO_GET_EXCELREPORTELIO}`,
      { Authorization: `Bearer ${token}` },
      {
        ...search,
        ORDENADOPOR: "ID",
        ORIENTACION: "DESC",
        PAGINA: 1,
        PAGINADO: ROW_COUNT_MAX,
      }
    )
      .then((r) => {
        if (r.httpCode === 204) {
          //Si se envia por correo el excel
          sendingEmail = true;
        } else {
          let file = r.result;
          let fileURL = URL.createObjectURL(file);
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.download = "ReporteLIO.xlsx";
          fileLink.click();
        }
      })
      .catch((e) => console.log(e));
    return sendingEmail;
  }

  public static async getExcelReporteSabanaLIO(token: string, search: ISearchReporteSabanaLIO) {
    let sendingEmail = false;
    await getAPIBlob(`${URL_LIO}${API_LIO_GET_EXCELREPORTESABANALIO}`, { Authorization: `Bearer ${token}` }, search)
      .then((r) => {
        if (r.httpCode === 204) {
          //Si se envia por correo el excel
          sendingEmail = true;
        } else {
          let file = r.result;
          let fileURL = URL.createObjectURL(file);
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.download = "ReporteSabanaLIO.xlsx";
          fileLink.click();
        }
      })
      .catch((e) => console.log(e));
    return sendingEmail;
  }

  public static async desactivarRegistroLIO(token: string, value: IDesactivarRegistro): Promise<number> {
    try {
      let result = await postAPI(`${URL_LIO}${API_DESVIACION_POST_DESACTIVARLIO}`, value, {
        Authorization: `Bearer ${token}`,
      });
      return result.result.data.data;
    } catch (error: any) {
      console.error(error);
      return -1;
    }
  }

  public static async eliminarRegistroLIO(token: string, value: IDesactivarRegistro): Promise<number> {
    try {
      let result = await deleteAPI(
        `${URL_LIO}${API_DESVIACION_DELETE_ELIMINARLIO}`,
        {
          Authorization: `Bearer ${token}`,
        },
        value
      );
      return result.result.data.data;
    } catch (error: any) {
      console.error(error);
      return -1;
    }
  }

  public static async desactivarRegistroLIOAspecto(token: string, value: IDesactivarRegistro): Promise<number> {
    try {
      let result = await postAPI(`${URL_LIO}${API_DESVIACION_POST_DESACTIVARLIOASPECTO}`, value, {
        Authorization: `Bearer ${token}`,
      });
      return result.result.data.data;
    } catch (error: any) {
      console.error(error);
      return -1;
    }
  }

  public static async eliminarRegistroLIOAspecto(token: string, value: IDesactivarRegistro): Promise<number> {
    try {
      let result = await deleteAPI(
        `${URL_LIO}${API_DESVIACION_DELETE_ELIMINARLIOASPECTO}`,
        {
          Authorization: `Bearer ${token}`,
        },
        value
      );
      return result.result.data.data;
    } catch (error: any) {
      console.error(error);
      return -1;
    }
  }

  public static async getListadoReporteEtapasDecisionesLIO(token: string, search: ISearchReporteEtapasDecisionesLIO) {
    try {
      let result = (
        await getAPI(
          `${URL_LIO}${API_LIO_GET_LISTADO_REPORTE_ETAPAS_DECISIONES}`,
          { Authorization: `Bearer ${token}` },
          {
            ...search,
          }
        )
      ).result;

      return result;
    } catch (e) {
      return false;
    }
  }

  public static async getExcelReporteEtapasDecisionesLIO(token: string, search: ISearchReporteEtapasDecisionesLIO) {
    let sendingEmail = false;
    await getAPIBlob(`${URL_LIO}${API_LIO_GET_EXCEL_REPORTE_ETAPAS_DECISIONES_LIO}`, { Authorization: `Bearer ${token}` }, search)
      .then((r) => {
        if (r.httpCode === 204) {
          //Si se envia por correo el excel
          sendingEmail = true;
        } else {
          let file = r.result;
          let fileURL = URL.createObjectURL(file);
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.download = "ReporteEtapasDecisionesLIO.xlsx";
          fileLink.click();
        }
      })
      .catch((e) => console.log(e));
    return sendingEmail;
  }
}
